export async function cancelQueries(queryClient, queryKeys) {
  await queryKeys.forEach((key) => {
    queryClient.cancelQueries(key);
  });
}
